module.exports = "/assets/src/client/assets/topLevelPage/styled-Cross.svg";